//
// "as" type safety
//
//
// Compose types
//

/**
 * Generic name to any dictionary.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * Generic set of module to class name map.
 */

/**
 * Generic class resolver function type.
 */

/**
 * Merged ComposeOptions.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
//
// Component types
//
//
// Slot Prop / Shorthand types
//
//
//
//
export var defaultComposeOptions = {
  className: process.env.NODE_ENV === 'production' ? '' : 'no-classname-🙉',
  classes: [],
  displayName: '',
  displayNames: [],
  mapPropsToStylesPropsChain: [],
  render: function render() {
    return null;
  },
  handledProps: [],
  overrideStyles: false,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  slots: {
    __self: function __self() {
      return null;
    }
  },
  slotProps: [],
  state: function state(props) {
    return props;
  },
  resolveSlotProps: function resolveSlotProps() {
    return {};
  },
  shorthandConfig: {}
};
/**
 * A set of mapped props for intrinsic element types.
 */

export var defaultMappedProps = {
  iframe: 'src',
  img: 'src',
  input: 'type'
};
/**
 * React.ForwardRef with static props
 */